(() => {
  const image = document.getElementById("gallery-image");
  const caption = document.getElementById("gallery-caption");
  const controls = document.getElementById("gallery-controls");
  if (!image || !caption || !controls) return;

  const buttons = [...controls.querySelectorAll("button[data-gallery-image]")]
    .filter((button) => button.dataset.galleryImage);
  if (!buttons.length) return;

  const original = document.getElementById("gallery-original");
  let active;

  function show(button) {
    active = button;
    const photo = button.dataset;
    image.alt = photo.galleryAlt || "";
    image.dataset.fit = photo.galleryFit === "contain" ? "contain" : "cover";
    if (photo.gallerySrcset) image.setAttribute("srcset", photo.gallerySrcset);
    else image.removeAttribute("srcset");
    image.src = photo.galleryImage;
    caption.textContent = photo.galleryCaption || "";
    if (original) original.href = photo.galleryImage;
    buttons.forEach((control) => control.setAttribute("aria-pressed", String(control === button)));
  }

  buttons.forEach((button) => button.addEventListener("click", () => show(button)));
  image.addEventListener("error", () => {
    // The first photo is also the no-JavaScript fallback. Never retry it in a loop.
    if (active !== buttons[0]) show(buttons[0]);
  });

  show(buttons.find((button) => button.getAttribute("aria-pressed") === "true") || buttons[0]);
  controls.hidden = false;
})();
